import { UserRole } from '../types/auth.types';

export const CREATOR_PORTAL_ROLES: UserRole[] = [UserRole.CREATOR];

export function hasCreatorPortalRole(roles: UserRole[] | string[] | undefined): boolean {
  if (!roles?.length) return false;
  return roles.includes(UserRole.CREATOR);
}
